import {createStore} from "redux";
import {reducer, initialState} from "reducers/index";


const store = createStore(reducer, initialState);


export default store;
